import { Component, Inject, LOCALE_ID } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { PrintLanguageDialog } from '../../shared/controls/print-language-dialog/print.language.dialog';
import { AbstractBiditComponent } from '../../shared/controls/abstract.bidit.component';
import { PrintChangeOrderOptions } from '../models/print.change.order.options.interface';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RolePermission } from '../../shared/models/role.permission.enum';
import { JobService } from '../services/job.service';
import { QuoteService } from '../../quote/services/quote.service';

export interface ChangeOrderPrintDialogData {
  isInvoice: false;
}

@Component({
  selector: 'app-change-order-print-dialog',
  templateUrl: './change.order.print.dialog.html',
  styleUrls: ['./change.order.print.dialog.scss']
})

export class ChangeOrderPrintDialog extends AbstractBiditComponent {
  locale: string = 'en';
  showPricing: boolean = false;
  showSquareFootage: boolean = false;
  showTaxes: boolean = false;
  isInvoice: boolean = false;
  showLinePricing: boolean = false;
  hideLineItemNotes: boolean = false;

  printChangeOrderOptions: PrintChangeOrderOptions = {} as PrintChangeOrderOptions;

  constructor(@Inject(LOCALE_ID) locale: string,
    deviceDetectorService: DeviceDetectorService,
    public dialogRef: MatDialogRef<PrintLanguageDialog>,
    @Inject(MAT_DIALOG_DATA) public data: ChangeOrderPrintDialogData) {
    super(deviceDetectorService);

    this.locale = locale;
    this.isInvoice = data.isInvoice;
    this.showLinePricing = JobService.hasPermission(RolePermission.ShowLineItemPricing);


  }

  printReport(): void {
    this.printChangeOrderOptions.locale = this.locale;
    this.printChangeOrderOptions.showSqrFt = this.showSquareFootage;
    this.printChangeOrderOptions.showPricing = this.showPricing;
    this.printChangeOrderOptions.showTax = this.showTaxes;
    this.printChangeOrderOptions.hideLineItemNotes = this.hideLineItemNotes;
    this.dialogRef.close(this.printChangeOrderOptions);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
